var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.spans),function(span){return _c('span',{class:span.class},[_vm._v(_vm._s(span.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }